module.exports = __webpack_public_path__ + "img/dh.470d696.png";